import { object, string } from "yup";

export const editCategorySchema = object({
  title: string().required("Title is required"),
});
